import home from './src/home.vue'
import dynEnvironmentAlarmView from './src/dynEnvironmentManager/dynEnvironmentAlarmView.vue' //动环设备列表
import dynEnvironmentAlarmInfo from './src/dynEnvironmentManager/dynEnvironmentAlarmInfo.vue' //动环设备详情
import DynamicEnvEquipView from './src/DynamicEnvironmentEquipment/DynamicEnvEquipView' //动环设备管理列表页
import DynamicEnvRecordsInfo from './src/DynamicEnvironmentEquipment/DynamicEnvRecordsInfo.vue' //动环设备管理详情页
import DynamicEnvEquipInfo from './src/DynamicEnvironmentEquipment/DynamicEnvEquipInfo' //动环设备管理列表页
import DynamicEnvRecords from './src/DynamicEnvironmentEquipment/DynamicEnvRecords.vue' //动环设备监测记录


let views = {
    home,
    dynEnvironmentAlarmView,
    dynEnvironmentAlarmInfo,
    DynamicEnvEquipView,
    DynamicEnvRecordsInfo,
    DynamicEnvEquipInfo,
    DynamicEnvRecords
};

export default views;